import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
  AbstractControl,
  ValidationErrors,
  UntypedFormArray,
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import {
  SuccessMessages,
  ErrorMessages,
  ActionMessages,
  REGEX,
} from "src/app/shared/constants/utility.constants";
import { ToastrService } from "ngx-toastr";
import { NavigationService } from "src/app/shared/services/navigation.service";
import { AppRouteConstants, PathRouteConstants } from "src/app/shared/constants/app-route.constants";
import { LessonConstants } from "../../constants/lesson-constants";
import { LessonsApiService } from "../../services/lessons-api.service";
import { LessonCurriculumApiService } from "../../services/lesson-curriculum-api.service";
import { Lesson } from "../../models/lesson";
import { catchError, takeUntil } from "rxjs/operators";
import { forkJoin, of, Subject } from "rxjs";
import { ApiDataService } from "src/app/shared/services/api.service";
import { Grade } from "src/app/shared/models/grade";
import { editorConfig } from "../../constants/editor-constants";
import { CK_EDITOR_CONFIG } from "../../constants/ckEditor.constants";
import { SharedDialogService } from "src/app/shared/services/shared-dialog.service";
import { UtilityService } from "src/app/shared/services/utility.service";
import { MatDialog } from "@angular/material/dialog";
import { HttpStatus } from "src/app/shared/constants/http-status.constants";
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import { LessonPassageConstants } from 'src/app/shared/constants/utility.constants';


@Component({
    selector: "app-update-lesson",
    templateUrl: "./update-lesson.component.html",
    styleUrls: ["./update-lesson.component.css"],
    standalone: false
})

export class UpdateLessonComponent implements OnInit, OnDestroy {
  ngUnsubscribe = new Subject <void>();
  updateLessonForm: UntypedFormGroup;
  isEditMode: boolean = false;
  lessonId: number;
  editLesson: boolean;
  submitted = false;
  validationFlash = false;
  loading = false;
  editorContent: string[] = [];
  lessonToEdit: Lesson = {};
  secImages: string[] = [];
  terImages: string[] = [];
  quatImages: string[] = [];
  inputName: string = 'inputName';
  allGrades: Grade[];
  passageIds: Lesson[] = [];
  lessonPassageByGrade: Lesson[];
  lessonPassageByGradeStore: Lesson[];
  filteredLessonPassagesByRow: any[][] = [];
  selectedPassageIds: any[] = [];
  passageDetails: any = [];
  images: any[] = [];
  indexBasedImages: any[] = [];
  boardId: UntypedFormControl;
  primaryImageName = LessonConstants.PRIMARY_IMAGE_LITERAL;
  secondaryImageName = LessonConstants.SECONDARY_IMAGE_LITERAL;
  terImageName = LessonConstants.TERRITIARY_IMAGE_LITERAL;
  quatImageName = LessonConstants.QUATENARY_IMAGE_LITERAL;
  summary: string;
  hideDropdown: string = LessonPassageConstants.HIDE_DROPDOWN;
  showDropdown: string = LessonPassageConstants.SHOW_DROPDOWN;
  radioButtonItems: any = [
    { selectedOption: this.hideDropdown },
    { selectedOption: this.hideDropdown },
  ]

    editorConfig = editorConfig;
  curriculumOptions: any[] = [];
  allCurriculumOptions: any[] = [];
  // Yearly Plan (lesson curriculum) dropdown options
  lessonCurriculumOptions: any[] = [];
  allLessonCurriculumOptions: any[] = [];
  selectedCurriculum: (number | null)[] = [null, null];
  lessonPassagesByCurriculum: any[][] = [[], []];
  allLessonPassagesByCurriculum: any[][] = [[], []];
  passageImages: string[][] | any = [[]]; // Array of arrays to store images for each passage
  previewImageUrl: string = '';
  curriculumName: string | null = null;
  @ViewChild('imagePreviewDialog') imagePreviewDialog: any;
  public Editor = DecoupledEditor;
  public ckConfig = CK_EDITOR_CONFIG


  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private lessonsApiService: LessonsApiService,
    private lessonCurriculumApiService: LessonCurriculumApiService,
    private toastrService: ToastrService,
    private navigationService: NavigationService,
    private sharedApiService: ApiDataService,
    private sharedDialogservice: SharedDialogService,
    private apiService: ApiDataService,
    private dialog: MatDialog
  ) {
    this.updateLessonForm = new UntypedFormGroup({
      curriculum_name: new UntypedFormControl(null, [Validators.required]),
      lesson_plan_name: new UntypedFormControl("", [
        Validators.required,
        Validators.pattern(/^(?=.*\S).+$/),
      ]),
      summary: new UntypedFormControl(null, UpdateLessonComponent.editorRequired),
      grade_id: new UntypedFormControl(null, Validators.required),
      lesson_plan_number: new UntypedFormControl("", [
        Validators.required,
        Validators.pattern(/^(?!0$)(\d\d{0,2}|1000000)$/),
      ]),
      passage: new UntypedFormArray([]),
      be_the_difference: new UntypedFormControl("", [
        Validators.required,
        Validators.pattern(REGEX.EASY_READ_LINK)
      ]),
      ufli_strategies: new UntypedFormControl(""),
      easy_read: new UntypedFormControl("",[Validators.required, Validators.pattern(REGEX.EASY_READ_LINK)]),
      read_with: new UntypedFormControl("",[Validators.required, Validators.pattern(REGEX.EASY_READ_LINK)]),
      embedded_video_url: new UntypedFormControl("", [
      Validators.pattern(REGEX.EASY_READ_LINK)
    ]),
    });
  }

  ngOnInit() {
    this.editActions();
    this.getGrades();
    this.getFinishedPassageCurriculums();
    this.getLessonCurriculums();
    this.updateLessonForm.get('summary').valueChanges
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => this.updateTutorTipsValidationState());
    this.updateLessonForm.get('grade_id').valueChanges
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.filterCurriculumOptionsBySelectedGrade();
        this.filterAllLessonPassagesBySelectedGrade();
      });
    this.getPassageCurriculums();
    this.route.queryParams.pipe(takeUntil(this.ngUnsubscribe)).subscribe(params => {
      this.curriculumName = params['curriculum_name'] || null;
      if (this.curriculumName) {
        this.updateLessonForm.get('curriculum_name')?.setValue(this.curriculumName);
      }
    });

    if (!this.editLesson) {
      (this.updateLessonForm.get('passage') as UntypedFormArray).push(this.createElementGroup());
      (this.updateLessonForm.get('passage') as UntypedFormArray).push(this.createElementGroup());
    }
  }

  createElementGroup(): UntypedFormGroup {
    return new UntypedFormGroup({
      passage_name: new UntypedFormControl(""),
      word_count: new UntypedFormControl(""),
      passage_summary: new UntypedFormControl(""),
      images: new UntypedFormControl([]),
    });
  }

  get passage(): UntypedFormArray {
    return this.updateLessonForm.get('passage') as UntypedFormArray;
  }

  getPassageControl(index: number): UntypedFormGroup {
    return (this.updateLessonForm.get('passage') as UntypedFormArray).at(index) as UntypedFormGroup;
  }

  updatePassageFormGroup(index: number, passage: any) {
    this.getPassageControl(index).patchValue({
      passage_name: passage?.passage_name || '',
      word_count: passage?.word_count || '',
      passage_summary: passage?.passage_summary || '',
    });
  }

  clearPassageFormGroup(index: number) {
    this.getPassageControl(index).patchValue({
      passage_name: '',
      word_count: '',
      passage_summary: '',
      images: [],
    });
  }

  editActions() {
    this.route.params
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((params) => {
        this.lessonId = +params.id;
        if (this.lessonId) {
          this.editLesson = true;
          this.getLesson();
        }
      });
  }

  getGrades() {
    this.sharedApiService
      .getAllGrades()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res) => {
          const refractoredData = res.sort((a, b) => {
            if (a.grade_level < b.grade_level) return -1;
            if (a.grade_level > b.grade_level) return 1;
            return 0;
          });
          this.allGrades = refractoredData;
        },
        (err) => {
          this.loading = false;
        }
      );
  }

  getPassageCurriculums() {
  this.lessonsApiService
    .getPassageCurriculums()
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(
      (res: any[]) => {
        this.curriculumOptions = (res || []).map((item: any) => ({
          value: item.id || item.passage_curriculum_id || item.passage_curriculum_name,
          label: item.passage_curriculum_name || item.name,
        }));
      },
      (err) => {
        this.loading = false;
      }
    );
}

  getFinishedPassageCurriculums() {
    this.lessonCurriculumApiService.getAllCurriculum('passage')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        if (res) {
          const finishedCurricula = res.filter(curriculum =>
            curriculum.is_finished === true || curriculum.is_finished === 1
          );

          if (!finishedCurricula.length) {
            this.allCurriculumOptions = [];
            this.curriculumOptions = [];
            return;
          }

          forkJoin(finishedCurricula.map(curriculum =>
            this.lessonCurriculumApiService.getCurriculum(curriculum.id)
              .pipe(catchError(() => of(curriculum)))
          ))
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((curricula: any[]) => {
              this.allCurriculumOptions = curricula;
              this.filterCurriculumOptionsBySelectedGrade();
            });
        }
      });
  }
        getLessonCurriculums() {
        this.lessonCurriculumApiService.getAllCurriculum('lesson_plan')
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(res => {
            if (res) {
              const curricula = res || [];

              if (!curricula.length) {
                this.allLessonCurriculumOptions = [];
                this.lessonCurriculumOptions = [];
                return;
              }
              forkJoin(curricula.map(curriculum =>
              this.lessonCurriculumApiService.getCurriculum(curriculum.id)
                .pipe(catchError(() => of(curriculum)))
            ))
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe((curricula: any[]) => {
                this.allLessonCurriculumOptions = curricula;
                this.filterLessonCurriculumOptionsBySelectedGrade();
              });
          }
        });
    }

  filterLessonCurriculumOptionsBySelectedGrade() {
    const selectedGradeId = this.updateLessonForm.get('grade_id')?.value;

    if (!selectedGradeId) {
      this.lessonCurriculumOptions = this.allLessonCurriculumOptions;
    } else {
      this.lessonCurriculumOptions = this.allLessonCurriculumOptions.filter(curriculum =>
        (curriculum.lessonPlans ?? []).some((lp: any) => lp.lesson_plan_id?.grade_id?.id === Number(selectedGradeId))
      );
    }
  }

  filterCurriculumOptionsBySelectedGrade() {
    const selectedGradeId = this.updateLessonForm.get('grade_id')?.value;

    if (!selectedGradeId) {
      this.curriculumOptions = this.allCurriculumOptions;
    } else {
      this.curriculumOptions = this.allCurriculumOptions.filter(curriculum =>
        this.curriculumHasSelectedGrade(curriculum, selectedGradeId)
      );
    }

    this.selectedCurriculum.forEach((curriculumId, index) => {
      if (!curriculumId) return;

      const selectedCurriculumStillAvailable = this.curriculumOptions.some(curriculum => curriculum.id === curriculumId);

      if (!selectedCurriculumStillAvailable) {
        this.selectedCurriculum[index] = null;
        this.allLessonPassagesByCurriculum[index] = [];
        this.lessonPassagesByCurriculum[index] = [];
        this.resetPassageSelection(index);
      }
    });
  }

  curriculumHasSelectedGrade(curriculum: any, selectedGradeId: number) {
    return (curriculum.passages ?? []).some(passageCurriculum =>
      passageCurriculum.passage_id?.grade_id?.id === Number(selectedGradeId)
    );
  }

  onCurriculumSelect(curriculumId: number, index: number) {
    this.resetPassageSelection(index);

    if (!curriculumId) {
      this.allLessonPassagesByCurriculum[index] = [];
      this.lessonPassagesByCurriculum[index] = [];
      return;
    }

    this.loadPassagesByCurriculum(curriculumId, index);
  }

  loadPassagesByCurriculum(curriculumId: number, index: number) {
    this.lessonCurriculumApiService.getCurriculum(curriculumId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        if (res) {
          this.allLessonPassagesByCurriculum[index] = (res.passages ?? [])
            .map(passageCurriculum => this.mapCurriculumPassage(passageCurriculum));
          this.filterLessonPassagesBySelectedGrade(index);
        }
      });
  }

  filterLessonPassagesBySelectedGrade(index: number) {
    const selectedGradeId = this.updateLessonForm.get('grade_id')?.value;

    if (!selectedGradeId) {
      this.lessonPassagesByCurriculum[index] = this.allLessonPassagesByCurriculum[index] || [];
    } else {
      this.lessonPassagesByCurriculum[index] = (this.allLessonPassagesByCurriculum[index] || [])
        .filter(passage => passage.grade_id?.id === selectedGradeId);
    }

    this.resetPassageSelection(index);
  }

  filterAllLessonPassagesBySelectedGrade() {
    this.allLessonPassagesByCurriculum.forEach((_, index) => {
      this.filterLessonPassagesBySelectedGrade(index);
    });
  }

  mapCurriculumPassage(passageCurriculum: any) {
    const passage = passageCurriculum.passage_id;

    return {
      passage_id: passage?.id,
      passage_name: passage?.passage_name,
      word_count: passage?.word_count,
      passage_summary: passage?.summary || '',
      grade_id: passage?.grade_id,
      primary_image_path: passage?.primary_image_path,
      sec_image_path: passage?.sec_image_path,
      ter_image_path: passage?.ter_image_path,
      quat_image_path: passage?.quat_image_path,
    };
  }

  resetPassageSelection(index: number) {
    delete this.passageDetails[index];
    delete this.selectedPassageIds[index];
    delete this.editorContent[index];
    this.images[index] = [];
    this.passageImages[index] = [];
    this.clearPassageFormGroup(index);
  }

  isLessonGradeSelected() {
    return !!this.updateLessonForm.get('grade_id')?.value;
  }

  isTutorTipsInvalid() {
    const summaryControl = this.updateLessonForm.get('summary');
    return (summaryControl?.hasError('required') || summaryControl?.hasError('emptyContent')) &&
      (this.updateLessonForm.get('summary')?.touched || this.submitted);
  }

  isPassageSelectionInvalid(index: number) {
    return !this.lessonId && this.submitted && this.isLessonGradeSelected() && !this.passageDetails[index];
  }

  showLessonGradeRequiredMessage() {
    if (!this.isLessonGradeSelected()) {
      this.toastrService.error('Please select a grade level first');
    }
  }

  onPassageSelect(event: any, passage: any, index: number) {
    if (event.isUserInput) {
      if (this.selectedPassageIds.includes(passage?.passage_id)) {
        this.toastrService.error(ErrorMessages.DUPLICATE_PASSAGE_SELECTED);
        this.selectedPassageIds[index] = passage?.passage_id;
        delete this.passageDetails[index];
        delete this.editorContent[index];
        this.clearPassageFormGroup(index);
      } else {
        passage.passage_summary = passage.passage_summary || '';
        this.passageDetails[index] = passage;
        this.selectedPassageIds[index] = passage?.passage_id;
        this.editorContent[index] = passage?.passage_summary;
        this.updatePassageFormGroup(index, passage);

        const imagePaths = [
          passage?.primary_image_path,
          passage?.sec_image_path,
          passage?.ter_image_path,
          passage?.quat_image_path,
        ].filter(p => !!p);

        if (imagePaths.length) {
          imagePaths.forEach(p => this.indexBasedImages.push({ path: p }));
        } else {
          this.indexBasedImages.push({ path: 'assets/images/noimage.jpg' });
        }

        this.images[index] = this.indexBasedImages
        this.indexBasedImages = []
    }
  }
}

 onRadioChange(index: number, option: string) {
    this.radioButtonItems[index].selectedOption = option
    delete this.passageDetails[index]
    delete this.selectedPassageIds[index]
    delete this.editorContent[index]
    this.images[index] = []
    this.passageImages[index] = []
    const formArray = this.updateLessonForm.get('passage') as UntypedFormArray;
    const formGroup = formArray.at(index) as UntypedFormGroup;
    formGroup.get('passage_name').setValue("")
    formGroup.get('word_count').setValue("")
  }

  miroBoardValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    const miroPattern = /^https:\/\/miro\.com\/app\/board\/[\w-]+=\/?$/;
    const isValid = miroPattern.test(value);

    if (!value || !isValid) {
      return { invalidMiroBoardLink: true };
    }
    return null;
  }
  
 validateEditorContent(value) {
  let content = value || '';
  const strippedContent = content.replace(/<\/?[^>]+(>|$)/g, "");
  const parser = new DOMParser();
  const decodedContent = parser.parseFromString(strippedContent, 'text/html').body?.textContent || "";
  if (decodedContent?.trim()?.length === 0) {
    return false;
  } else {
    return true;
  }
}

  static editorRequired(control: AbstractControl): ValidationErrors | null {
    const content = (control.value || '').replace(/<\/?[^>]+(>|$)/g, "");
    const decoded = new DOMParser().parseFromString(content, 'text/html').body?.textContent || "";
    return decoded.trim().length === 0 ? { required: true } : null;
  }

  updateTutorTipsValidationState() {
    const summaryControl = this.updateLessonForm.get('summary');
    if (!summaryControl) return;

    const errors = { ...(summaryControl.errors || {}) };
    delete errors.emptyContent;

    if (!this.validateEditorContent(summaryControl.value)) {
      errors.emptyContent = true;
    }

    summaryControl.setErrors(Object.keys(errors).length ? errors : null);
  }

  triggerValidationFlash() {
    this.validationFlash = false;
    requestAnimationFrame(() => {
      this.validationFlash = true;
    });
  }

  getLesson() {
    this.loading = true;
    this.lessonsApiService
      .getLesson(this.lessonId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res) => {
          if (res) {
            const formArray = this.updateLessonForm.get('passage') as UntypedFormArray;
            formArray.clear(); 
            this.lessonToEdit = res;
            this.setForm();
            this.loading = false;
          }
          setTimeout(() => {
            this.loading = false;
          }, 4000);
        },
        (err) => {
          this.loading = false;
        }
      );
  }

  setForm() {
    try {
      (this.updateLessonForm.get('passage') as UntypedFormArray).push(this.createElementGroup());
      (this.updateLessonForm.get('passage') as UntypedFormArray).push(this.createElementGroup());
      this.lessonToEdit.passage?.forEach((elements, index) => {
        elements.passage_summary = elements.summary || elements.passage_summary || '';
        this.editorContent[index] = elements?.passage_summary;
        this.passageIds.push(elements?.id);
        
        // Initialize passage images array
        this.passageImages[index] = [];
        
        // Add existing images to the array
        if (elements?.passage_images?.length) {
          this.passageImages[index] = elements.passage_images.map(img => img.image_path);
        }
        
        delete elements?.id;
        delete elements?.summary;
        delete elements?.created_at;
        delete elements?.updated_at;
        delete elements?.updated_by;
        delete elements?.created_by;
        delete elements?.is_deleted;
      });

          const currentCurriculumName =
            this.lessonToEdit?.curriculum_name ||
            this.lessonToEdit?.lesson_plan_curriculum_name ||
            this.lessonToEdit?.curriculum_names?.[0] ||
            null;

          const currentGradeId =
            this.lessonToEdit?.grade_id?.id ??
            this.lessonToEdit?.grade_id ??
            "";

          this.updateLessonForm.patchValue({
      curriculum_name: currentCurriculumName,

      lesson_plan_name: this.lessonToEdit?.lesson_plan_name || "",
      summary: this.lessonToEdit?.summary || "",
      grade_id: currentGradeId,
      lesson_plan_number: this.lessonToEdit?.lesson_plan_number || "",
      passage: this.lessonToEdit?.passage,
      be_the_difference: this.lessonToEdit?.be_the_difference || "",
      ufli_strategies: this.lessonToEdit?.ufli_strategies || "",
      easy_read: this.lessonToEdit?.easy_read || "",
      read_with: this.lessonToEdit?.read_with || "",
      embedded_video_url: this.lessonToEdit?.embedded_video_url || ""
    });
    } catch (error) {
      console.log('ERROR: Error when setting form!');
    }
  }

  uploadPassageImage(index: number) {
    document.getElementById(`passage_images_${index}`).click();
  }

  async onPassageImageUpload(event: any, index: number) {
    const files = event.target.files;
    if (files) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (file) {
          const isImage = file?.type?.startsWith('image/');
          const isMismatch = !isImage || !["image/png", "image/jpg", "image/jpeg"]?.includes(file.type);

          if (isMismatch) {
            this.toastrService.error(ErrorMessages.IMAGE_TYPE_MISMATCH);
            continue;
          }

          const reader = new FileReader();
          reader.onload = (e: any) => {
            const readerResult = e.target.result;
            this.getPreviewImage(readerResult, file.size, index);
          };
          reader.readAsDataURL(file);
        }
      }
      event.target.value = '';
    }
  }

  getPreviewImage(readerResult: any, fileSize: number, index: number): void {
    const image = new Image();
    image.src = readerResult;
    image.onload = () => {
      if (fileSize > 5 * 1024 * 1024) { // 5MB limit
        this.toastrService.error(ErrorMessages.IMAGE_SIZE_EXCEEDED);
      } else {
        if (!this.passageImages[index]) {
          this.passageImages[index] = [];
        }

        const imageCount = this.passageImages[index]?.length || 0;
        // imageCount includes extra one image which is the one being uploaded : IMAGE LIMIT IS 20
        if (imageCount >= LessonConstants.IMAGE_LIMIT) { 
          this.toastrService.error(ErrorMessages.IMAGE_LIMIT_EXCEEDED);
        } else {
          this.passageImages[index].push(readerResult);
        }
      }
    };
    image.onerror = (error) => {
      console.error('Error: Image Loading Error', error);
    };
  }

  deletePassageImage(passageIndex: number, imageIndex: number) {
    this.sharedDialogservice
      .ConfirmAction({
        title: "Delete image",
        message: UtilityService.replaceText(
          ActionMessages.DELETE_CONFIRMATION,
          [{ text: "_name", data: "image" }]
        ),
      })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (subscribeRes) => {
        if (subscribeRes) {
          this.passageImages[passageIndex].splice(imageIndex, 1);
          
          const passageControl = this.getPassageControl(passageIndex);
          const imagesControl = passageControl.get('images');
          if (imagesControl) {
            imagesControl.setValue(this.passageImages[passageIndex]);
          }
        }
      });
  }

  replaceBase64String(imgURL: string) {
    return imgURL?.replace(/^data:image\/[a-z]+;base64,/, "")
  }

  async updateLesson(lesson) {
    this.submitted = true;
    this.triggerValidationFlash();
    this.updateTutorTipsValidationState();
    this.updateLessonForm.markAllAsTouched();

    if (this.updateLessonForm.invalid) {
      this.loading = false;
      this.toastrService.error('Please complete all required fields.');
      return;
    }

    const formData = { ...this.updateLessonForm.value };
    const selectedCurriculum = this.updateLessonForm.get('curriculum_name')?.value || this.curriculumName;
    if (selectedCurriculum) {
      formData.curriculum_name = selectedCurriculum;
    }
    formData.passage?.forEach((elements, index) => {
      elements.images = this.passageImages[index]?.map(img => this.replaceBase64String(img)) || [];
    });
    this.loading = true;
    let formCompleted = true
    let passageSelected = true
    const passageArray = this.updateLessonForm.get('passage') as UntypedFormArray;
    const numberOfFields = passageArray.length;
    if (!this.editLesson) {
      this.createLessonDetails(formData, formCompleted, passageSelected, numberOfFields)
    } else {
      this.saveLessonDetails(formData, formCompleted);
    }
  }

  createLessonDetails(lesson, formCompleted, passageSelected, numberOfFields) {
    if (this.updateLessonForm.invalid) {
      formCompleted = false;
      this.loading = false;
    }
    for (let i = 0; i < numberOfFields; i++) {
      if (!this.passageDetails[i]) {
        passageSelected = false;
        this.loading = false;
        break;
      }
    }
    if (formCompleted && passageSelected) {
      const validateSummary = this.validateEditorContent(lesson?.summary);
      if (!validateSummary) {
        formCompleted = false;
        this.loading = false;
      }
    }
    // Require Yearly Plan (lesson curriculum) when creating
    if (!this.updateLessonForm.get('curriculum_name')?.value) {
      this.toastrService.error('Yearly Plan is required.');
      this.submitted = true;
      this.loading = false;
      return;
    }

    this.uploadLessonDetails(lesson, formCompleted, passageSelected);
  }

  uploadLessonDetails(lesson, formCompleted, passageSelected) {
    if (formCompleted && passageSelected) {
      lesson.passage?.forEach((passages, index) => {
        passages.id = this.selectedPassageIds[index]
      })
      // prefer selected form value, fall back to query param
      const selectedCurriculum = this.updateLessonForm.get('curriculum_name')?.value;
      if (selectedCurriculum) {
        lesson.curriculum_name = selectedCurriculum;
      } else if (this.curriculumName) {
        lesson.curriculum_name = this.curriculumName;
      }
      this.lessonsApiService
        .createLesson(lesson)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (res) => {
            if (res?.statusCode === HttpStatus.STATUS_OK) {
              this.toastrService.success(SuccessMessages.CREATE_LESSON);
              this.navigateBack();
              this.loading = false;
            }
          },
          (error) => {
            if (error.status === HttpStatus.STATUS_PAYLOAD_TOO_LARGE) {
              this.toastrService.error(ErrorMessages.UNSUPPORTED_IMAGE_FOUND);
            } else {
              this.toastrService.error(error?.error?.ResponseMessage);
            }
            this.loading = false;
          }
        )
    } else if (!passageSelected) {
      this.toastrService.error(ErrorMessages.PASSAGE_NOT_SELECTED);
      this.loading = false
    } else {
      this.toastrService.error('Please complete all required fields.');
      this.loading = false
    }
  }

  saveLessonDetails(lesson, formCompleted) {
    lesson.id = this.lessonId;
    lesson.curriculum_name = lesson.curriculum_name || this.updateLessonForm.get('curriculum_name')?.value || this.curriculumName;

    if (!lesson.curriculum_name) {
      this.toastrService.error('Yearly Plan is required.');
      this.loading = false;
      return;
    }

    if (this.updateLessonForm.valid) {
      lesson?.passage?.forEach((passages, index) => {
        const validateSummary = this.validateEditorContent(lesson?.summary)
        if (validateSummary) {
          const validatePassageSummary = this.validateEditorContent(passages?.passage_summary)
          if (!validatePassageSummary) {formCompleted = false; this.loading = false;}
        } else {
          formCompleted = false
          this.loading = false;
        }
      })
    } 
    this.uploadEditedLessonDetails(lesson, formCompleted);
  }

  uploadEditedLessonDetails(lesson, formCompleted) {
    if (this.updateLessonForm.valid && formCompleted) {
      lesson?.passage?.forEach((passages, index) => {
        passages.id = this.passageIds[index]
      })
      this.lessonsApiService
        .updateLesson(lesson)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (res) => {
            if (res?.statusCode === HttpStatus.STATUS_OK) {
              this.toastrService.success(SuccessMessages.UPDATE_LESSON);
              this.navigateBack();
              this.loading = false;
            }
          },
          (errorRes) => {
            if (errorRes.status === HttpStatus.STATUS_PAYLOAD_TOO_LARGE) {
              this.toastrService.error(ErrorMessages.UNSUPPORTED_IMAGE_FOUND);
            } else {
              this.toastrService.error(errorRes?.error?.ResponseMessage);
            }
            this.loading = false;
          }
        );
    } else {
      this.toastrService.error('Please complete all required fields.');
      this.loading = false;
    }
  }
  
  updateLessons(lesson) {
    try {
      lesson.id = this.lessonId;
      lesson.passage?.forEach((passages, index) => {
        passages.id = this.passageIds[index]
      })
      this.lessonsApiService
        .updateLesson(lesson)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (res) => {
            if (res.statusCode === HttpStatus.STATUS_OK) {
              const formArray = this.updateLessonForm.get('passage') as UntypedFormArray;
              formArray.clear(); 
              this.toastrService.success(
                SuccessMessages.UPDATE_LESSON_IMAGE
              );
              this.loading = false;
              this.getLesson();
            } else {
              this.toastrService.error(ErrorMessages.LESSON_DELETE);
            }
          },
          (error) => {
            this.toastrService.error(ErrorMessages.UNSUPPORTED_IMAGE_FOUND);
            this.loading = false;
          }
        );
      } catch (error) {
        console.group('Error deleting image')
      }
  }

  onEditorReady(editor: any) {
    editor.ui.getEditableElement().parentElement.insertBefore(
      editor.ui.view.toolbar.element,
      editor.ui.getEditableElement()
    );
  }

  navigateBack() {
    this.loading = false;
    this.location.back();
  }

  goToEditPassage(index: number) {
    const passageId = this.passageIds[index];
    if (!passageId) return;
    this.navigationService.navigateToPage([
      PathRouteConstants.PASSAGES +
        UtilityService.replaceText(AppRouteConstants.PASSAGE_UPDATE, [{ text: ':id', data: passageId }])
    ]);
  }

  validateNumber(e, length) {
    if (
      !(
        (e.keyCode > 95 && e.keyCode < 106) ||
        (e.keyCode > 47 && e.keyCode < 58) ||
        e.keyCode == 8
      )
    ) {
      return false;
    } else if (e.target.value.length == length) return false;
  }

  numbersOnly(controlName: string) {
    const control = this.updateLessonForm.get(controlName);
    const value = String(control.value || '').replace(/[^0-9]/g, '');
    control.setValue(value, { emitEvent: false });
  }

  validateSpace(event: KeyboardEvent, controlName?: string): void {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.value;
    const isSpace = event.key === ' ';

    if (isSpace) {
      const cursorPosition = inputElement.selectionStart;
      if (controlName === this.inputName) {
        if (cursorPosition === 0 || (value[cursorPosition - 1] === ' ' && cursorPosition > 0)) {
          event.preventDefault();
        } 
      } else if (cursorPosition === 0) {
          event.preventDefault();
    }
  }
  } 

  ngOnDestroy() {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }

  previewImage(imageUrl: string) {
    this.previewImageUrl = imageUrl;
    this.dialog.open(this.imagePreviewDialog, {
      width: '100%',
      height: '100%',
      maxWidth: '100vw',
      maxHeight: '100vh',
      panelClass: 'fullscreen-dialog'
    });
  }

  closePreview() {
    this.dialog.closeAll();
  }
}
